import { AxiosResponse} from "axios";
import Api from "../api";

export default (listingId : number): Promise<AxiosResponse> => {
    const path = `/listings/listing-view/${listingId}/v3`
    return Api.getInstance(false,false,process.env.REACT_APP_API_SUB_URL).request.get(`${path}`, path)
}